import React from 'react';
import { IOldIconProps } from './type';

const Paypal: React.FC<IOldIconProps> = ({
  width = 36,
  height = 24,
  color: _color = '#000',
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="0.5"
        y="0.5"
        width={35}
        height={23}
        rx="1.5"
        fill="white"
        stroke="#DFE4F3"
      />
      <g clipPath="url(#clip0_1017_1586)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2796 11.8237L16.4368 10.8183L16.0866 10.8101H14.4143L15.5765 3.39106C15.5801 3.36859 15.5918 3.34774 15.6089 3.3329C15.6261 3.31806 15.648 3.30992 15.6708 3.30992H18.4905C19.4266 3.30992 20.0726 3.50601 20.4098 3.8931C20.568 4.07469 20.6687 4.2645 20.7175 4.47331C20.7686 4.69245 20.7694 4.95424 20.7196 5.27359L20.7159 5.29682V5.50146L20.8741 5.5917C21.0072 5.6628 21.113 5.74416 21.1942 5.83734C21.3294 5.99268 21.4169 6.19002 21.4538 6.4239C21.4921 6.6645 21.4795 6.95088 21.4169 7.27506C21.3448 7.6479 21.2281 7.97268 21.0706 8.23836C20.9258 8.48322 20.7412 8.68632 20.522 8.8437C20.3128 8.99322 20.0642 9.10674 19.7831 9.1794C19.5107 9.2508 19.2002 9.2868 18.8596 9.2868H18.6402C18.4834 9.2868 18.331 9.34368 18.2113 9.44568C18.0913 9.54978 18.012 9.69204 17.9876 9.84762L17.9711 9.93816L17.6933 11.7102L17.6807 11.7752C17.6774 11.7958 17.6717 11.8061 17.6632 11.813C17.6557 11.8194 17.645 11.8237 17.6344 11.8237H16.2796Z"
          fill="#28356A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.0237 5.32049C21.0154 5.37467 21.0057 5.43 20.9949 5.48694C20.6231 7.4091 19.3509 8.07318 17.7262 8.07318H16.8989C16.7002 8.07318 16.5327 8.21838 16.5018 8.41578L15.9583 11.8869C15.9382 12.0166 16.0373 12.1333 16.1672 12.1333H17.6344C17.8082 12.1333 17.9558 12.0062 17.9831 11.8337L17.9975 11.7586L18.2738 9.99354L18.2915 9.8967C18.3186 9.7236 18.4665 9.5964 18.6402 9.5964H18.8596C20.2812 9.5964 21.3941 9.01536 21.7193 7.33374C21.8552 6.63132 21.7849 6.04476 21.4253 5.6322C21.3166 5.50788 21.1816 5.40462 21.0237 5.32049Z"
          fill="#298FC2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6347 5.16431C20.5779 5.14761 20.5193 5.13252 20.4591 5.11888C20.3987 5.10556 20.3368 5.09378 20.2731 5.08344C20.0501 5.04715 19.8056 5.02994 19.5439 5.02994H17.3338C17.2793 5.02994 17.2277 5.04232 17.1814 5.0647C17.0795 5.11404 17.0038 5.2112 16.9854 5.33014L16.5152 8.3283L16.5018 8.41578C16.5327 8.21838 16.7002 8.07318 16.8989 8.07318H17.7262C19.3509 8.07318 20.6231 7.4091 20.9949 5.48694C21.0057 5.43 21.0154 5.37467 21.0237 5.32049C20.9297 5.27023 20.8277 5.22722 20.718 5.19059C20.6909 5.18152 20.663 5.17279 20.6347 5.16431Z"
          fill="#22284F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.9854 5.33014C17.0038 5.2112 17.0795 5.11404 17.1814 5.0647C17.2277 5.04232 17.2793 5.02994 17.3338 5.02994H19.5439C19.8056 5.02994 20.0501 5.04715 20.2731 5.08344C20.3368 5.09378 20.3987 5.10556 20.4591 5.11888C20.5193 5.13252 20.5779 5.14761 20.6347 5.16431C20.663 5.17279 20.6909 5.18152 20.718 5.19059C20.8277 5.22722 20.9297 5.27023 21.0237 5.32049C21.1343 4.61016 21.0231 4.12651 20.6417 3.68855C20.2211 3.20635 19.4621 3 18.4909 3H15.6712C15.4728 3 15.3035 3.14522 15.2729 3.34292L14.0984 10.8382C14.0753 10.9865 14.1889 11.1203 14.3374 11.1203H16.0782L16.9854 5.33014Z"
          fill="#28356A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.97177 13.8643H5.91595C5.77525 13.8643 5.6556 13.9672 5.63362 14.107L4.80214 19.4147C4.78564 19.5195 4.86622 19.6138 4.97172 19.6138H5.95317C6.09389 19.6138 6.21353 19.511 6.23549 19.3709L6.45971 17.9392C6.48137 17.7991 6.60125 17.6962 6.74171 17.6962H7.39247C8.74667 17.6962 9.52823 17.0364 9.73241 15.7289C9.82439 15.1569 9.73631 14.7075 9.47021 14.3927C9.17807 14.0471 8.65979 13.8643 7.97177 13.8643ZM8.20889 15.8029C8.09651 16.5455 7.53287 16.5455 6.98789 16.5455H6.67763L6.89531 15.1585C6.90827 15.0746 6.98033 15.0129 7.06451 15.0129H7.20677C7.57799 15.0129 7.92815 15.0129 8.10911 15.226C8.21705 15.353 8.25005 15.5419 8.20889 15.8029Z"
          fill="#28356A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1695 15.7388H13.185C13.1011 15.7388 13.0286 15.8005 13.0157 15.8843L12.9721 16.1615L12.9033 16.0611C12.6902 15.7496 12.2149 15.6455 11.7406 15.6455C10.6527 15.6455 9.72353 16.4752 9.54257 17.6389C9.44849 18.2193 9.58223 18.7744 9.90935 19.1615C10.2093 19.5174 10.6386 19.6658 11.1492 19.6658C12.0259 19.6658 12.5119 19.0983 12.5119 19.0983L12.468 19.3737C12.4515 19.479 12.5321 19.5734 12.637 19.5734H13.5238C13.6648 19.5734 13.7838 19.4705 13.806 19.3304L14.3381 15.9379C14.355 15.8335 14.2747 15.7388 14.1695 15.7388ZM12.7971 17.668C12.7021 18.2342 12.2558 18.6143 11.6864 18.6143C11.4005 18.6143 11.1721 18.522 11.0254 18.3471C10.8799 18.1734 10.8246 17.9261 10.8708 17.6506C10.9596 17.0893 11.4134 16.6967 11.9741 16.6967C12.2537 16.6967 12.4809 16.7903 12.6306 16.9666C12.7806 17.1449 12.8401 17.3937 12.7971 17.668Z"
          fill="#28356A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.3368 15.8236H18.3474C18.2531 15.8236 18.1644 15.8708 18.1109 15.9499L16.7465 17.9734L16.1681 16.0288C16.1317 15.9071 16.0202 15.8236 15.8939 15.8236H14.9218C14.8036 15.8236 14.7216 15.9399 14.7591 16.0519L15.8489 19.2715L14.8244 20.7276C14.7438 20.8423 14.825 21 14.9642 21H15.9522C16.0461 21 16.1338 20.954 16.187 20.8766L19.4774 16.0945C19.5562 15.9802 19.4753 15.8236 19.3368 15.8236Z"
          fill="#28356A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.6349 13.8643H20.5789C20.4385 13.8643 20.3188 13.9672 20.2969 14.107L19.4654 19.4147C19.4489 19.5195 19.5295 19.6138 19.6344 19.6138H20.6895C20.7874 19.6138 20.8713 19.5419 20.8866 19.4438L21.1226 17.9392C21.1442 17.7991 21.2642 17.6962 21.4046 17.6962H22.0552C23.4096 17.6962 24.1909 17.0364 24.3953 15.7289C24.4876 15.1569 24.3989 14.7075 24.1329 14.3927C23.8409 14.0471 23.323 13.8643 22.6349 13.8643ZM22.8721 15.8029C22.7599 16.5455 22.1963 16.5455 21.651 16.5455H21.3412L21.5591 15.1585C21.572 15.0746 21.6435 15.0129 21.728 15.0129H21.8702C22.2411 15.0129 22.5916 15.0129 22.7726 15.226C22.8805 15.353 22.9133 15.5419 22.8721 15.8029Z"
          fill="#298FC2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.8314 15.7388H27.8475C27.7631 15.7388 27.6912 15.8005 27.6786 15.8843L27.635 16.1615L27.5659 16.0611C27.3527 15.7496 26.8778 15.6455 26.4034 15.6455C25.3155 15.6455 24.3867 16.4752 24.2057 17.6389C24.1119 18.2193 24.245 18.7744 24.5721 19.1615C24.8727 19.5174 25.3013 19.6658 25.8121 19.6658C26.6887 19.6658 27.1747 19.0983 27.1747 19.0983L27.1309 19.3737C27.1144 19.479 27.1949 19.5734 27.3005 19.5734H28.1869C28.3272 19.5734 28.447 19.4705 28.4689 19.3304L29.0012 15.9379C29.0175 15.8335 28.9369 15.7388 28.8314 15.7388ZM27.4592 17.668C27.3648 18.2342 26.9177 18.6143 26.3484 18.6143C26.0631 18.6143 25.8341 18.522 25.6873 18.3471C25.5419 18.1734 25.4872 17.9261 25.5328 17.6506C25.6222 17.0893 26.0754 16.6967 26.6361 16.6967C26.9156 16.6967 27.1429 16.7903 27.2926 16.9666C27.4432 17.1449 27.5027 17.3937 27.4592 17.668Z"
          fill="#298FC2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.9101 14.0101L29.0663 19.4149C29.0498 19.5197 29.1302 19.6141 29.2352 19.6141H30.0835C30.2245 19.6141 30.3441 19.5113 30.3658 19.3711L31.1978 14.0637C31.2144 13.9589 31.1338 13.8643 31.0289 13.8643H30.079C29.9951 13.8645 29.923 13.9263 29.9101 14.0101Z"
          fill="#298FC2"
        />
      </g>
      <defs>
        <clipPath id="clip0_1017_1586">
          <rect
            width="26.4"
            height="18"
            fill="white"
            transform="translate(4.79999 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Paypal;
